import React from "react"
import Link from "next/link"

export function HeroImage(props) {
  const {
    heroTitle,
    heroDescription,
    heroImageSrc,
    heroImageAlt,
    featuredTextOne,
    featuredLinkOne,
    featuredButtonTextOne,
    featuredTextTwo,
    featuredLinkTwo,
    featuredButtonTextTwo,
  } = props

  return (
    <div className="bg-gray-900">
      <div className="relative isolate h-screen overflow-hidden pt-14">
        <img
          alt={heroImageAlt}
          src={heroImageSrc}
          className="absolute inset-0 -z-10 size-full object-cover object-left-top"
        />

        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2/3 py-32 sm:py-48 lg:py-56">
            <div className="text-center">
              <h1 className="text-5xl font-semibold tracking-tight text-balance text-white sm:text-7xl">
                {heroTitle}
              </h1>

              <p className="mt-8 text-lg font-medium text-pretty text-white sm:text-xl/8">
                {heroDescription}
              </p>

              <div className="mt-10 grid grid-cols-1 items-center justify-center gap-4 gap-x-6 lg:grid-cols-2">
                <div class="col-span-1 p-4">
                  <div class="p-4 text-xl text-white">{featuredTextOne}</div>
                  <Link
                    href={featuredLinkOne}
                    className="text-blac hidden items-center gap-x-1.5 rounded-full bg-white px-4 py-2 text-xs font-semibold sm:inline-flex sm:text-sm"
                  >
                    {featuredButtonTextOne} <span aria-hidden="true">→</span>
                  </Link>
                </div>
                <div class="col-span-1 p-4">
                  <div class="p-4 text-xl text-white">{featuredTextTwo}</div>
                  <Link
                    href={featuredLinkTwo}
                    className="hidden items-center gap-x-1.5 rounded-full bg-white px-4 py-2 text-xs font-semibold text-black sm:inline-flex sm:text-sm"
                  >
                    {featuredButtonTextTwo} <span aria-hidden="true">→</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
